const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://thainguyen-api.cgis.asia/",
  },
  production: {
    api: "https://thainguyen-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
